<!-- Hiding background of the modal -->
<div  *ngIf="showPopup" class="backdrop"></div>
<!-- Pop up modal container -->
<div  *ngIf="showPopup" class="popUp-modal-dialog">
    <div class="modal-content">
        <!-- Close button top right -->
        <div class="close-icon">
            <img (click)="onCancel()" id="close" src="assets\images\close_icon.png" alt="{{ 'ConnectionFailure.close' | translate }}" title="{{ 'ConnectionFailure.close' | translate }}">
        </div>
        <!-- Pop up message for error dash board-->
        <div class="popUp-message">
            <h5 class="popUP-modal-title">{{'ConnectionFailure.connectionPopUpmsg' | translate}}</h5>
        </div>
        <!-- Close button down -->
        <div class="popUp-footer">
            <button class="btn-SN-default" (click)="onCancel()">{{'ConnectionFailure.btnClose' | translate}}</button>
        </div>
    </div>
</div>